import React, { FC } from "react";
import { Col, Empty, Row } from "antd";
import { Loader, Page } from "shared/ui";
import { useGetMachineOverviewQuery } from "shared/api";
import { MachineCard } from "./ui";

const Overview: FC = () => {
  const { data, isLoading } = useGetMachineOverviewQuery();

  return (
    <Page title="Overview">
      {isLoading && (
        <div className="flex min-h-[calc(100dvh-11rem)] w-full items-center justify-center px-4">
          <Loader />
        </div>
      )}

      {!isLoading && !data?.length && (
        <div className="flex min-h-[calc(100dvh-11rem)] w-full items-center justify-center px-4">
          <Empty description="No machine data available" />
        </div>
      )}

      {!isLoading && !!data?.length && (
        <Row gutter={[16, 16]}>
          {data.map((item, index) => (
            <Col key={index} xs={24} sm={12} md={8} lg={4}>
              <MachineCard item={item} />
            </Col>
          ))}
        </Row>
      )}
    </Page>
  );
};

export { Overview };
